import { render, staticRenderFns } from "./AssetManager.vue?vue&type=template&id=e9413a6a&"
import script from "./AssetManager.vue?vue&type=script&lang=ts&"
export * from "./AssetManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports